import React from 'react'
import PropTypes from 'prop-types'
import { DividerSize, SetDotted, SetLine } from './style'
import { DIVIDER_SIZE } from '@helpers/constants'
import classNames from 'classnames'

const Divider = (props) => {
    const { size = DIVIDER_SIZE.MEDIUM, dotted, line, color } = props

    const className = classNames(DividerSize[size], color, {
        [`${SetDotted}`]: dotted,
        [`${SetLine}`]: line,
    })

    return <div className={className}></div>
}

Divider.propTypes = {
    size: PropTypes.string,
    dotted: PropTypes.bool,
    line: PropTypes.bool,
    color: PropTypes.any,
}

export default Divider
